module.exports = __webpack_public_path__ + "img/MTCIFCMB.09c5bea1.svg";